import React, { useEffect, useState } from 'react';
import '../App.css';
import moon from '../assets/images/moonOriginal.png';
import stars from '../assets/images/stars.jpg';
import road from '../assets/images/road.png';
import Spline from '@splinetool/react-spline';

const MoonParallax = () => {
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const onScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    const maxScale = 6;
    const moonScale = Math.min(1 + scrollY * 0.008, maxScale);
    const starsScale = 1 + scrollY * 0.0015;
    const roadTranslate = scrollY * 1.3;
    const roadScale = 1 + scrollY * 0.001;
    const textOpacity = Math.max(1 - scrollY * 0.002, 0);
    const showSpline = scrollY > 500;

    return (
        <div className="parallax-container">
            <img
                src={stars}
                alt="stars"
                className="stars"
                style={{ transform: `scale(${starsScale})` }}
            />

            {/* 2D Moon */}
            <img
                src={moon}
                alt="moon"
                className="moon"
                style={{
                    transform: `translate(-50%, -50%) scale(${moonScale})`,
                    opacity: showSpline ? 0 : 1,
                    pointerEvents: 'none',
                }}
            />

            {/* Spline Moon */}
            <div
                className="spline-moon"
                style={{
                    opacity: showSpline ? 1 : 0,
                    transform: `translate(-50%, -50%) scale(${moonScale})`,
                }}
            >
                <Spline scene="https://prod.spline.design/TWqwAETwup-2Be-a/scene.splinecode" />
            </div>

            {/* Text */}
            <div className="center-text" style={{ opacity: textOpacity }}>
                <h1>WHY WE ARE GOING BACK TO THE MOON</h1>
                <p className='para-text'>
                    NASA's return to the moon through the Artemis missions is driven by a multifaceted strategy aimed at advancing scientific knowledge, testing cutting-edge technologies, and laying the foundation for future human exploration beyond Earth...
                </p>
            </div>

            {/* Road */}
            <img
                src={road}
                alt="road"
                className="road"
                style={{
                    transform: `translateY(${roadTranslate}px) scale(${roadScale})`,
                }}
            />
        </div>
    );
};

export default MoonParallax;
